function initMobileMenu(){
    /*var scrollUpPoint = '992px';
    if (window.matchMedia("(max-width: "+scrollUpPoint+")").matches) {
        //$('#page-header').css('padding-top',$('#page-header .scrollbar').height() + 1);
        $('#page-header .scrollbar').addClass('scrollbar-mobile');
    }
    $(window).on('resize',function () {
        //recalc the needed top padding for the fixed header
        if (window.matchMedia("(max-width: "+scrollUpPoint+")").matches) {
            //$('#page-header').css('padding-top',$('#page-header .scrollbar').height() + 1);
            $('#page-header .scrollbar').addClass('scrollbar-mobile');
        }else{
            //$('#page-header').css('padding-top',0);
            $('#page-header .scrollbar').removeClass('scrollbar-mobile');
        }

    });*/
    //Mobi menu
    $('body .menu-button').on('click',function () {
        $('body').toggleClass('mobi-menu-open');
        $(this).toggleClass('is-active');
        $.scrollLock();
        if($('#page-header .navbar-main').height() <= $('#page-header .navbar-main .menu-lvl-0').height()){
            $('#page-header .navbar-main').css('overflow-y','scroll');
            $('#page-header .navbar-main .menu-lvl-0').addClass('static');
            $('#page-header .navbar-main .menu-lvl-0').css('top',$('#page-header .scrollbar').height() + 1);
        }else {
            $('#page-header .navbar-main .menu-lvl-0').removeClass('static');
            $('#page-header .navbar-main .menu-lvl-0').removeAttr('style');
        }
    })
    //
    // $('.navbar-main a').on('click',function () {
    //     if(/^#/.test($(this).attr('href'))) {
    //         $('body .hamburger').trigger('click');
    //     }
    // });
    var navControl = $('#page-header .scrollbar').first();
    var scrollBreakpoint = parseInt(window.getComputedStyle(navControl.get(0)).height) / 2;
    if ($(window).scrollTop() > scrollBreakpoint) {
        navControl.addClass("scrollbar-down");
    }
    $(document).on('scrollUp', function () {
        if ($(window).scrollTop() < scrollBreakpoint) {
            navControl.removeClass("scrollbar-down");
        }
        //$(navControl).find('.logo').fadeIn();
    });
    $(document).on('scrollDown', function () {
        if ($(window).scrollTop() > scrollBreakpoint) {
            navControl.addClass("scrollbar-down");
            //$(navControl).find('.logo').fadeOut();
        }
    });

    $(".menu-toggle").click(function(event) {
        event.preventDefault();
        $(this).next(".collapse").collapse('toggle');
        $(this).toggleClass("collapsed");
    });

}